var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"machine-picture",attrs:{"src":`${_vm.image(_vm.elementId)}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }